const ENGLISH_ONLY_CURRENCIES = new Set(['GBP']);
const ENGLISH_ONLY_TIME_ZONES = new Set(['Europe/London']);

/**
 * Arabic is offered to Gulf tenants. UK tenants (GBP currency or London time)
 * are English-only: Arabic is hidden from language pickers and no Arabic
 * WhatsApp templates are created for them.
 */
export function isArabicOffered(
  currency: string | null | undefined,
  timeZone: string | null | undefined,
) {
  return (
    !ENGLISH_ONLY_CURRENCIES.has(currency ?? '') &&
    !ENGLISH_ONLY_TIME_ZONES.has(timeZone ?? '')
  );
}
